<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            PPE Dashboard
          </h1>
        </div>
      </div>
    </div>

    <!-- grid wrapper card -->
    <div
      class="wrapper-card grid lg:grid-cols-4 grid-cols-1 md:grid-cols-2 gap-2 mt-5"
    >
      <!-- card  -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-orange-200 rounded-full w-14 h-14 text-lg p-3 text-orange-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M10 16V8a2 2 0 0 1 2-2h9V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-1h-9a2 2 0 0 1-2-2zm3-8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h9V8h-9zm3 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            125
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">Total Detections Today
          </h2>
        </div>
      </div>
      <!-- end card -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-green-200 rounded-full w-14 h-14 text-lg p-3 text-green-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M5 22h14a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3v-.777c0-2.609-1.903-4.945-4.5-5.198A5.005 5.005 0 0 0 7 7v1H4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm12-12v2h-2v-2h2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-2 3h2v2H7v-2z"
                />
              </svg>
            </span>
          </div>
        </div>

<div class="block p-2 w-full">
  <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
    8
  </p>
  <h2 class="font-normal text-gray-400 text-md mt-1">Missing PPE Cases</h2>
  
  <!-- <div class="mt-2">
    <p class="text-gray-600 dark:text-gray-400 text-sm">5 – No Helmet</p>
    <p class="text-gray-600 dark:text-gray-400 text-sm">3 – No Safety Shoes</p>
  </div> -->
</div>
      </div>
      <!-- end card -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-red-200 rounded-full w-14 h-14 text-lg p-3 text-red-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 32 32"
              >
                <path
                  fill="none"
                  d="M8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0ZM20.5 12.5A4.5 4.5 0 1 1 16 8a4.5 4.5 0 0 1 4.5 4.5Z"
                />
                <path
                  fill="currentColor"
                  d="M26.749 24.93A13.99 13.99 0 1 0 2 16a13.899 13.899 0 0 0 3.251 8.93l-.02.017c.07.084.15.156.222.239c.09.103.187.2.28.3c.28.304.568.596.87.87c.092.084.187.162.28.242c.32.276.649.538.99.782c.044.03.084.069.128.1v-.012a13.901 13.901 0 0 0 16 0v.012c.044-.031.083-.07.128-.1c.34-.245.67-.506.99-.782c.093-.08.188-.159.28-.242c.302-.275.59-.566.87-.87c.093-.1.189-.197.28-.3c.071-.083.152-.155.222-.24ZM16 8a4.5 4.5 0 1 1-4.5 4.5A4.5 4.5 0 0 1 16 8ZM8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0Z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            2
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">
            Unauthorized Access
          </h2>
        </div>
      </div>
      <!-- end card -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-purple-200 rounded-full w-14 h-14 text-lg p-3 text-purple-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 16 16"
              >
                <g fill="currentColor">
                  <path d="M15 13v1H1.5l-.5-.5V0h1v13h13Z" />
                  <path
                    d="M13 3.207L7.854 8.354h-.708L5.5 6.707l-3.646 3.647l-.708-.708l4-4h.708L7.5 7.293l5.146-5.147h.707l2 2l-.707.708L13 3.207Z"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
           6  Areas
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">Areas Monitored
          </h2>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end wrapper card -->
    <div class="mt-2 lg:flex block lg:gap-2 relative">
      <!-- <div
      class="bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 overflow-hidden"
    >
      <h1 class="text-center text-lg font-semibold mb-2"></h1>
      <img 
        alt="Live camera feed 1 showing factory floor"
        class="rounded-md w-full h-[400px] object-cover"
        src="https://storage.googleapis.com/a1aa/image/L5CJsEIuZXHWOuKsfPdJ28KQUQkEUwcWzGQgsAqJJGU.jpg"
      />
    </div>     -->

    <div
  class="bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 overflow-hidden"
>
  <h1 class="text-center text-lg font-semibold mb-2"></h1>
  <video 
  class="rounded-md w-full h-[400px] object-cover"
  controls
  autoplay
  loop
  muted
>
  <source src="/videoplayback.mp4" type="video/mp4" />
  Your browser does not support the video tag.
</video>
</div>
      <div
        class="bg-white dark:bg-gray-800 p-5 lg:mt-0 mt-4 lg:w-2/4 border dark:border-gray-700 rounded-md w-full"
      >
        <div class="">
          <h2 class="text-lg font-semibold dark:text-gray-200">
            Live Alerts
          </h2>
        </div>
        <perfect-scrollbar class="divide-y h-96 mt-5 dark:divide-gray-700">
          <!-- Critical Alerts (Red) -->
          <div class="p-3 w-full">
            <div class="bg-red-100 p-4 rounded-lg cursor-pointer">
              <div class="text-sm text-red-600 font-bold">
                🚨 David Clark – Entered without a face mask (Compliance Alert)
              </div>
            </div>
          </div>
          
          <div class="p-3 w-full">
            <div class="bg-red-100 p-4 rounded-lg cursor-pointer">
              <div class="text-sm text-red-600 font-bold">
                🚨 Unknown person detected at 10:45 AM (Unauthorized Access)
              </div>
            </div>
          </div>
        
          <!-- Caution Alerts (Yellow) -->
          <div class="p-3 w-full">
            <div class="bg-yellow-100 p-4 rounded-lg cursor-pointer">
              <div class="text-sm text-yellow-600 font-bold">
                ⚠️ Robert Brown is late (9:30 AM) (Check PPE compliance)
              </div>
            </div>
          </div>
        
          <div class="p-3 w-full">
            <div class="bg-yellow-100 p-4 rounded-lg cursor-pointer">
              <div class="text-sm text-yellow-600 font-bold">
                ⚠️ Michael Scott detected without ID badge at 9:15 AM
              </div>
            </div>
          </div>
        
          <!-- Positive Alerts (Green) -->
          <div class="p-3 w-full">
            <div class="bg-green-100 p-4 rounded-lg cursor-pointer">
              <div class="text-sm text-green-600 font-bold">
                ✅ Alice Green checked in at 8:45 AM (On time & compliant)
              </div>
            </div>
          </div>
        
          <div class="p-3 w-full">
            <div class="bg-green-100 p-4 rounded-lg cursor-pointer">
              <div class="text-sm text-green-600 font-bold">
                ✅ Jane Smith checked out at 5:00 PM (Compliant)
              </div>
            </div>
          </div>
        </perfect-scrollbar>
        
      </div>
    </div>
    <!-- <div class="mt-2 lg:flex block lg:gap-2">
      <div
        class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700"
      >
        <div class="head p-5">
          <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            1,780
          </h2>
          <p class="text-gray-400 font-lexend font-normal">
            New products this week
          </p>
          <span class="float-right">
            <h2 class="text-green-500 -mt-12 flex">
              <span class="mr-2"> 27.9% </span
              ><span>
                <Icon icon="akar-icons:arrow-up" />
              </span>
            </h2>
          </span>
        </div>
        <div class="wrapper-chart mt-5 pr-2 pl-2">
          <apexchart
            width="100%"
            height="380"
            type="bar"
            :options="optionsBar"
            :series="seriesBar"
          ></apexchart>
          <br />
          <hr />
          <div class="footer p-5">
            <div class="wrapper-button flex justify-between mt-3">
              <select
                name=""
                id=""
                class="dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 border max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
              >
                <option value="">Last 7 days</option>
              </select>
              <button class="uppercase border-b border-red-600 text-red-600">
                Product Report
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700"
      >
        <div class="head p-5">
          <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            5,355
          </h2>
          <p class="text-gray-400 font-lexend font-normal">Visitor this week</p>

          <span class="float-right">
            <h2 class="text-green-500 -mt-12 flex">
              <span class="mr-2"> 47.9% </span
              ><span>
                <Icon icon="akar-icons:arrow-up" />
              </span>
            </h2>
          </span>
        </div>
        <div class="wrapper-chart mt-5">
          <apexchart
            width="100%"
            height="380"
            type="area"
            :options="optionsVisitor"
            :series="seriesVisitor"
          ></apexchart>
          <br />
          <hr />
          <div class="footer p-5">
            <div class="wrapper-button flex justify-between mt-3">
              <select
                name=""
                id=""
                class="dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 border max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
              >
                <option value="">Last 7 days</option>
              </select>
              <button class="uppercase border-b border-red-600 text-red-600">
                Vistor Report
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700"
      >
        <div class="head p-5">
          <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            475
          </h2>
          <p class="text-gray-400 font-lexend font-normal">
            User signups this week
          </p>
        </div>

        <div class="wrapper-chart mt-5">
          <apexchart
            width="100%"
            height="380"
            type="pie"
            :options="optionsDonut"
            :series="seriesDonut"
          ></apexchart>
          <div class="p-3"></div>
          <br />
          <hr />
          <div class="footer p-5">
            <div class="wrapper-button flex justify-between mt-3">
              <select
                name=""
                id=""
                class="dark:bg-gray-800 dark:hover:bg-gray-700 border dark:border-gray-700 max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
              >
                <option value="">Last 7 years</option>
              </select>

              <button class="uppercase border-b border-red-600 text-red-600">
                User Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> -->



<!--  -->

<div class="mt-2 lg:flex block lg:gap-2">
  <!-- Total Attendance Today -->
  <div class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700">
    <div class="head p-5">
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">{{ totalDetections }}</h2>
      <p class="text-gray-400 font-lexend font-normal">Total Detections Today</p>
      <span class="float-right">
        <h2 class="text-green-500 -mt-12 flex">
          <span class="mr-2"> +12% </span>
          <span><Icon icon="akar-icons:arrow-up" /></span>
        </h2>
      </span>
    </div>
    <div class="wrapper-chart mt-5 pr-2 pl-2">
      <apexchart width="100%" height="380" type="bar" :options="optionsBar" :series="seriesBar"></apexchart>
    </div>
  </div>
  
  <!-- Compliance Percentage -->
  <div class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700">
    <div class="head p-5">
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">{{ compliancePercentage }}%</h2>
      <p class="text-gray-400 font-lexend font-normal">Compliance Percentage</p>
    </div>
    <div class="wrapper-chart mt-5">
      <apexchart width="100%" height="380" type="area" :options="optionsArea" :series="seriesArea"></apexchart>
    </div>
  </div>
  
  <!-- Violations Breakdown -->
  <div class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700">
    <div class="head p-5">
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">{{ totalViolations }}</h2>
      <p class="text-gray-400 font-lexend font-normal">Total Violations</p>
    </div>
    <div class="wrapper-chart mt-5">
      <apexchart width="100%" height="380" type="pie" :options="optionsPie" :series="seriesPie"></apexchart>
    </div>
  </div>
</div>
    <!--  -->

    
    <div class="mt-5 w-full">
      <div class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between">
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Violation Logs
          </h1>
        </div>
        <div class="flex gap-2">
          <button
            class="bg-primary border flex gap-2 text-white hover:bg-primary/80 dark:border-gray-700 rounded py-3 px-5"
            @click="exportToPDF"
          >
            <span class="icon text-2xl"></span>
            <span class="text">Export Report</span>
          </button>
        </div>
      </div>
    </div>
    <div class="wrapping-table mt-10">
      <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll border border-gray-300 dark:border-gray-600 shadow-md rounded-lg">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400 border-b border-gray-300 dark:border-gray-600">
          <tr>
            <th scope="col" class="uppercase px-6 py-3 border-r">Employee ID</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Employee Name</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Department</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">PPE Status</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Date & Time</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Location</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Device</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Duration</th>
            <th scope="col" class="uppercase px-6 py-3">Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-700" v-for="log in ppeLogs" :key="log.id">
            <td class="px-6 py-4 border-r">{{ log.id }}</td>
            <td class="px-6 py-4 border-r">{{ log.employee }}</td>
            <td class="px-6 py-4 border-r">{{ log.department }}</td>
            <td class="px-6 py-4 border-r">
              <span class="px-3 py-1 rounded-md" 
                :class="{
                  'text-green-800 bg-green-300': log.ppeStatus === 'Compliant',
                  'text-red-800 bg-red-300': log.ppeStatus === 'Non-Compliant',
                  'text-yellow-800 bg-yellow-300': log.ppeStatus === 'Pending',
                }">
                {{ log.ppeStatus }}
              </span>
            </td>
            <td class="px-6 py-4 border-r">{{ log.datetime }}</td>
            <td class="px-6 py-4 border-r">{{ log.location }}</td>
            <td class="px-6 py-4 border-r">{{ log.device }}</td>
            <td class="px-6 py-4 border-r">{{ log.duration }}</td>
            <td class="px-6 py-4">{{ log.remarks }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="wrapper-button flex justify-between mt-3">
      <select
        name=""
        id=""
        class="dark:bg-gray-800 dark:hover:bg-gray-700 border dark:border-gray-700 max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
      >
        <option value="">Last 7 days</option>
      </select>
    </div>
</diV>    
</template>

<script>
  // @ is an alias to /src
  import { Icon } from "@iconify/vue";
  import Alert from "@/components/Alert.vue";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  export default {
    name: "Dashboard",
    data() {
      return {
        totalDetections: 123,
      compliancePercentage: 35,
      totalViolations: 45,
      optionsBar: {
        chart: { type: 'bar' },
        xaxis: { categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], title: { text: 'Days of the Week' } },
        yaxis: { title: { text: 'Total Detections' } },
      },
      seriesBar: [{ name: 'Attendance', data: [30, 50, 60, 40, 80, 90, 100] }],

      optionsArea: {
        chart: { type: 'area' },
        xaxis: { categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'], title: { text: 'Weeks' } },
        yaxis: { title: { text: 'Compliance Percentage' } },
      },
      seriesArea: [{ name: 'Compliance', data: [25, 45, 55, 39] }],

      optionsPie: {
        labels: ['Late Arrivals', 'No ID', 'PPE Violation', 'Unauthorized Access'],
      },
      seriesPie: [15, 10, 12, 8],
        // for more guide apexchart.js
        // https://apexcharts.com/docs/chart-types/line-chart/

        seriesDonut: [20, 15, 63, 83],
        ppeLogs: [
      { 
        id: 1, 
        employee: "John Doe", 
        department: "IT", 
        ppeStatus: "Compliant", 
        datetime: "2025-03-29 09:00 AM", 
        location: "Main Gate", 
        device: "CCTV", 
        duration: "8h", 
        remarks: "Proper PPE worn" 
      },
      { 
        id: 2, 
        employee: "Jane Smith", 
        department: "HR", 
        ppeStatus: "Non-Compliant", 
        datetime: "2025-03-29 05:00 PM", 
        location: "Exit Gate", 
        device: "Biometric", 
        duration: "8h", 
        remarks: "No face mask" 
      },
      { 
        id: 3, 
        employee: "Robert Brown", 
        department: "Finance", 
        ppeStatus: "Non-Compliant", 
        datetime: "2025-03-29 09:30 AM", 
        location: "Main Gate", 
        device: "RFID", 
        duration: "7.5h", 
        remarks: "No helmet" 
      },
      { 
        id: 4, 
        employee: "Alice Green", 
        department: "Marketing", 
        ppeStatus: "Compliant", 
        datetime: "2025-03-29 08:45 AM", 
        location: "Side Entrance", 
        device: "CCTV", 
        duration: "8h", 
        remarks: "Proper PPE worn" 
      },
   
    ]
      };
      // end chart data line
    },
    components: {
      Icon,
      Alert
    },
    mounted() {
    setInterval(this.updateCharts, 3000);
  },
  methods: {
    updateCharts() {
      this.totalDetections = Math.floor(Math.random() * 200) + 100;
      this.compliancePercentage = Math.floor(Math.random() * 50) + 30;

      this.seriesBar = [{
        name: 'Attendance',
        data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 100) + 20)
      }];
      
      this.seriesArea = [{
        name: 'Compliance',
        data: Array.from({ length: 4 }, () => Math.floor(Math.random() * 60) + 20)
      }];
    },
    exportToPDF() {
  const doc = new jsPDF();

  // **🔹 Define Assets**
  const brandName = "Logic Clutch Software LLP";
  const reportTitle = "PPE Compliance Report";
  const logoPath = "/lc_logo.png"; // Ensure the logo is in the `public` folder

  const img = new Image();
  img.src = logoPath;
  img.onload = () => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // **✅ Add Company Logo & Name at the Top**
    doc.addImage(img, "PNG", 10, 10, 30, 30); // Small logo at the top-left
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text(brandName, 45, 25);

    // **✅ Add Report Title**
    doc.setFontSize(22);
    doc.setTextColor(40, 40, 40);
    doc.text(reportTitle, 10, 50);

    // **✅ Add Professional Line Below Title**
    doc.setLineWidth(0.5);
    doc.line(10, 55, 200, 55);

    // **✅ Add Blurred Watermark Logo with Opacity**
    doc.setGState(new doc.GState({ opacity: 0.15 })); // 🔹 Lower opacity for a subtle effect
    doc.addImage(img, "PNG", pageWidth / 4, pageHeight / 4, 100, 100, '', 'FAST');
    doc.setGState(new doc.GState({ opacity: 1 })); // Reset opacity for next elements

    // **✅ Table Headers (Styled & Bold)**
    const tableStartY = 65;
    const tableColumn = ["Emp ID", "Emp Name", "PPE Status", "Remarks", "Location"];
    const tableRows = this.ppeLogs.map(log => [
      log.id, 
      log.employee, 
      log.ppeStatus, 
      log.remarks, 
      log.location
    ]);

    let y = tableStartY;

    // **🔹 Draw Table Headers**
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setFillColor(50, 50, 150); // 🔹 Dark blue header background
    doc.setTextColor(255, 255, 255); // 🔹 White text
    doc.rect(10, y - 5, 190, 8, "F");

    tableColumn.forEach((col, index) => {
      doc.text(col, 15 + index * 35, y);
    });

    y += 10;

    // **🔹 Draw Table Rows with Alternating Colors**
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    tableRows.forEach((row, rowIndex) => {
      doc.setFillColor(rowIndex % 2 === 0 ? 245 : 230, 230, 230); // 🔹 Light gray alternation
      doc.setTextColor(0, 0, 0);
      doc.rect(10, y - 5, 190, 8, "F");

      row.forEach((cell, index) => {
        doc.text(String(cell), 15 + index * 35, y);
      });

      y += 10;
    });

    // **✅ Add Footer Line**
    doc.setLineWidth(0.5);
    doc.line(10, y + 5, 200, y + 5);

    // **✅ Save PDF**
    doc.save("PPE_Compliance_Report.pdf");
  };

  img.onerror = () => {
    console.error("Error loading the logo image. Make sure it's in the public folder.");
  };
}
  }}
  </script>
